import { Route, Navigate, useParams } from 'react-router-dom'
import { ApprovalRouteMobile, ApprovalKitInboxPageMobile } from './lazy/mobile'
import {
  MobileHomePage, MobileMoldDetail, MobileDailyChecklist, MobilePeriodicInspection,
  MobileRepairRequestForm, RepairRequestListPage, MobileRepairShipmentChecklist,
  MobileDevelopmentPlan, MobileMoldChecklist, MobileMoldNurturing,
  MobileHardnessMeasurement, MobileMoldSpecification, MobileInjectionCondition,
  MobileInjectionHistory, MobileInjectionStats, MobileTransferList,
  MobileTransferRequest, MobileTryoutIssue, MobileDocuments, MobilePhotoGallery,
  MobileMoldHistory, MobileMaintenancePage, MobileMaintenanceTasksUnified, MobileProductionTransferChecklist,
  MobileInspectionApproval, MobileRepairList, MobileHqRepairList,
  MobileMakerRepairList, MobileMakerMoldDetail, MobileMoldList,
  MobileMoldLifecycle, MobileMoldQRCode, MobileMoldQRBind, MobileLocationMap,
  MobileInspectionNew, MobileWorkflow,
  MobilePreProductionChecklist, MobileScrappingPage, MobileCompanyList,
  MobileCompanyDetail, MobileAlerts, MobileNotificationCenter, MobileReports, MobileBoard,
  ChecklistSelectPage, ChecklistFormPage, ChecklistCompletePage,
  MobileDashboard, MobileSearch, MobilePlantMoldSelect, MobileUserRequests,
  MobileQRSessions, MobileProfile, MobileCompanyProfile, MobileNotificationSettings, MobileHelp,
  ChecklistStartPage, TransferManagement, TransferRequest,
  MobileMoldRepairHistory, MobileMoldInspectionHistory, MobileOverShotMoldList, MobileInspectionDueMoldList,
  // 2026-07-08: PC 파리티 신규 3건
  MobileMoldTransferHistory, MobileMoldScrappingProgress, MobileDelegationsPage, MoldingAnalysis,
  AsMoldRegistryPage,
  MobileMoldNew, MobileMoldRegistration,
  // Phase D — PC 파리티 신규 5건
  MobilePartnerUsers, MobilePartnerInjectionSummary, MobilePartnerEquipmentSummary,
  MobileInvestment, MobileInternalUsers,
  MobilePartnerPaintLineSummary, MobileRiskMonitorDashboard, MobilePartnerOperations,
  // 2026-09-01: 협력사 재무현황 (조회 전용)
  MobilePartnerFinance,
  // 2026-09-17: 대여자산 실사 (SP-1 조회 전용)
  MobileAssetAudit,
  // Phase D 추가 — 시스템 관리자 모바일 대시보드
  SystemAdminMobileDashboard,
  // Phase G-2: Task Center
  MobileTaskCenter,
  // Phase HU: 더보기 메뉴 (하단바 5번째 탭)
  MobileMore,
  // Phase HV: KPI 시각화 페이지
  MobileKPIDashboard, AlertDetail } from './lazyRoutes'
import MobileProtectedRoute from '../components/mobile/MobileProtectedRoute'

// 역할 상수 (가독성)
const R = {
  ADMIN: 'system_admin',
  DEV: 'mold_developer',
  STAFF: 'staff',
  PLANT: 'plant',
  MAKER: 'maker',
}
// 역할 조합 프리셋
const ADMIN_ONLY = [R.ADMIN]
// Phase GK: system-admin 기본 대시보드 — admin/dev/staff 동등 접근 (sub-routes 는 ADMIN_ONLY 유지)
const ADMIN_DEV_STAFF = [R.ADMIN, R.DEV, R.STAFF]
const ADMIN_DEV = [R.ADMIN, R.DEV]
const ADMIN_DEV_PLANT = [R.ADMIN, R.DEV, R.PLANT]
const MAKER_ONLY = [R.MAKER]
const PLANT_ONLY = [R.PLANT]
// P3: 제작처 금형 상세 — 백엔드는 admin/dev/staff 도 허용 (PC pcRoutes:252 파리티)
const ADMIN_DEV_STAFF_MAKER = [R.ADMIN, R.DEV, R.STAFF, R.MAKER]
const PARTNER_OPS_ROLES = [R.ADMIN, R.DEV, R.STAFF, R.MAKER, R.PLANT]
// P3: QR 바인딩 — 백엔드 molds.js:81-91 은 plant 자사 양산금형 바인딩 허용 (admin/dev/staff + plant)
const QR_BIND_ALLOWED = [R.ADMIN, R.DEV, R.STAFF, R.PLANT]
// QR 출력/조회 — PC와 동일: 생산처 차단 (GPS 임의 등록 방지), 본사·담당자·제작처 허용
const QR_OUTPUT_ALLOWED = [R.ADMIN, R.DEV, R.STAFF, R.MAKER]
// Phase BI: 점검 작성 권한 — Phase AO H-1 INSPECTOR_ROLES (admin/dev/staff/plant). maker 차단.
const INSPECTOR_ROLES = [R.ADMIN, R.DEV, R.STAFF, R.PLANT]
// Phase BI: 점검 승인 권한 — admin/dev/staff (본사). plant/maker 차단.
const APPROVER_ROLES = [R.ADMIN, R.DEV, R.STAFF]
// 2026-10-13: 금형이력 — PC pcRoutes 'mold-history' 와 동일 (admin/dev/staff + 협력사).
//   서버 moldHistory.js HISTORY_READ_ROLES 도 동일하며 협력사는 자사 금형만·비용은 마스킹된다.
const HISTORY_READ_ROLES = [R.ADMIN, R.DEV, R.STAFF, R.PLANT, R.MAKER]

// 헬퍼: 권한 래퍼
const guard = (element, roles) => (
  <MobileProtectedRoute allowedRoles={roles}>{element}</MobileProtectedRoute>
)

/**
 * 모바일 인증 필요 라우트 (MobileAuthGuard 하위)
 * App.jsx에서 {mobileRoutes}로 삽입
 */
export const mobileRoutes = [
  /* 홈 */
  <Route key="m-home" path="/mobile/home" element={<MobileHomePage />} />,
  <Route key="m-board" path="/mobile/board" element={<MobileBoard />} />,
  <Route key="m-board-detail" path="/mobile/board/:id" element={<MobileBoard />} />,
  <Route key="m-root" path="/mobile" element={<MobileHomePage />} />,

  /* 알림 클릭 → 승인 페이지 자동 오픈 딥링크 (approval-kit) */
  <Route key="m-approval-deeplink" path="/mobile/approvals/:policyId/:targetId" element={<ApprovalRouteMobile />} />,

  /* Kit 통합 승인함 (모바일) */
  <Route key="m-kit-inbox" path="/mobile/approval-inbox" element={<ApprovalKitInboxPageMobile />} />,

  // 2026-07-08: 승인 위임 관리 (PC /delegations 파리티 — ProtectedRoute 무역할 = 인증 사용자 전체)
  <Route key="m-delegations" path="/mobile/delegations" element={<MobileDelegationsPage />} />,
  // 2026-07-20: 성형해석 검증 (PC /molding-analysis 파리티 — admin/dev/staff, PC 메뉴 등록과 동일 스코프)
  <Route key="m-molding-analysis" path="/mobile/molding-analysis" element={guard(<MoldingAnalysis />, ADMIN_DEV_STAFF)} />,
  // 2026-09-23: A/S 금형 대장 (PC /as-molds 재사용) — 보관 현장에서 핸드폰 GPS 로 위치를 등록한다
  <Route key="m-as-molds" path="/mobile/as-molds" element={guard(<AsMoldRegistryPage />, ADMIN_DEV_STAFF)} />,

  /* 금형 상세 & 하위 기능 */
  <Route key="m-mold" path="/mobile/mold/:moldId" element={<MobileMoldDetail />} />,
  <Route key="m-daily" path="/mobile/mold/:moldId/daily-check" element={guard(<MobileDailyChecklist />, INSPECTOR_ROLES)} />,
  <Route key="m-periodic" path="/mobile/mold/:moldId/periodic-check" element={guard(<MobilePeriodicInspection />, INSPECTOR_ROLES)} />,
  // Phase JX C1: query-param 진입 alias (MobileInfoTab StatusCards 호환)
  <Route key="m-daily-alias" path="/mobile/daily-checklist" element={guard(<MobileDailyChecklist />, INSPECTOR_ROLES)} />,
  <Route key="m-periodic-alias" path="/mobile/periodic-inspection" element={guard(<MobilePeriodicInspection />, INSPECTOR_ROLES)} />,
  <Route key="m-repair-req" path="/mobile/mold/:moldId/repair-request" element={<MobileRepairRequestForm />} />,
  <Route key="m-repair-list" path="/mobile/mold/:moldId/repair-list" element={<RepairRequestListPage />} />,
  <Route key="m-repair-ship" path="/mobile/mold/:moldId/repair-shipment-checklist" element={<MobileRepairShipmentChecklist />} />,
  <Route key="m-dev-plan" path="/mobile/mold/:moldId/development-plan" element={<MobileDevelopmentPlan />} />,
  <Route key="m-checklist" path="/mobile/mold/:moldId/mold-checklist" element={<MobileMoldChecklist />} />,
  <Route key="m-nurturing" path="/mobile/mold/:moldId/nurturing" element={<MobileMoldNurturing />} />,
  <Route key="m-hardness" path="/mobile/mold/:moldId/hardness" element={<MobileHardnessMeasurement />} />,
  <Route key="m-spec" path="/mobile/mold/:moldId/specification" element={<MobileMoldSpecification />} />,
  <Route key="m-inj-cond" path="/mobile/mold/:moldId/injection-condition" element={<MobileInjectionCondition />} />,
  <Route key="m-inj-hist" path="/mobile/mold/:moldId/injection-history" element={<MobileInjectionHistory />} />,
  <Route key="m-inj-stat" path="/mobile/mold/:moldId/injection-stats" element={<MobileInjectionStats />} />,
  <Route key="m-transfer" path="/mobile/mold/:moldId/transfer" element={<MobileTransferList />} />,
  <Route key="m-transfer-new" path="/mobile/mold/:moldId/transfer/new" element={<MobileTransferRequest />} />,
  <Route key="m-transfer-list" path="/mobile/mold/:moldId/transfer/list" element={<MobileTransferList />} />,
  <Route key="m-tryout" path="/mobile/mold/:moldId/tryout-issues" element={<MobileTryoutIssue />} />,
  <Route key="m-docs" path="/mobile/mold/:moldId/documents" element={<MobileDocuments />} />,
  <Route key="m-photos" path="/mobile/mold/:moldId/photos" element={<MobilePhotoGallery />} />,
  <Route key="m-history" path="/mobile/mold/:moldId/history" element={guard(<MobileMoldHistory />, HISTORY_READ_ROLES)} />,
  <Route key="m-maint-mold" path="/mobile/mold/:moldId/maintenance" element={<MobileMaintenancePage />} />,
  <Route key="m-pt-check" path="/mobile/mold/:moldId/production-transfer-checklist" element={<MobileProductionTransferChecklist />} />,
  <Route key="m-insp-appr" path="/mobile/mold/:moldId/inspection-approval" element={guard(<MobileInspectionApproval />, APPROVER_ROLES)} />,
  <Route key="m-transfer-id" path="/mobile/transfer/:id" element={<MobileTransferList />} />,

  /* 웹버전 이관관리 */
  <Route key="m-tw" path="/mobile/mold/:moldId/transfer-web" element={<TransferManagement />} />,
  <Route key="m-tw-new" path="/mobile/mold/:moldId/transfer-web/new" element={<TransferRequest />} />,

  /* 수리관리 */
  <Route key="m-repairs" path="/mobile/repairs" element={<MobileRepairList />} />,
  // 2026-10-13: 수리요청 단건 열기 (PC /repair-request-form?id=N 파리티).
  //   MobileRepairRequestForm 은 useParams().id 로 읽으므로 **경로 파라미터**여야 한다 (?id= 는 무시됨).
  <Route key="m-repair-form-id" path="/mobile/repair-request-form/:id" element={<MobileRepairRequestForm />} />,

  /* 전체 이관 inbox — P1-3 */
  <Route key="m-transfers" path="/mobile/transfers" element={<MobileTransferList />} />,
  <Route key="m-hq-repair" path="/mobile/hq/repair-requests" element={guard(<MobileHqRepairList />, ADMIN_DEV)} />,
  <Route key="m-maker-repair" path="/mobile/maker/repair-requests" element={guard(<MobileMakerRepairList />, MAKER_ONLY)} />,
  // P3: MAKER_ONLY → +admin/dev/staff (백엔드/PC pcRoutes:252 파리티 — 본사도 제작처 뷰 접근 가능)
  <Route key="m-maker-mold" path="/mobile/maker/mold/:moldId" element={guard(<MobileMakerMoldDetail />, ADMIN_DEV_STAFF_MAKER)} />,

  /* 금형 관리 */
  <Route key="m-molds" path="/mobile/molds" element={<MobileMoldList />} />,
  <Route key="m-mold-list" path="/mobile/mold-list" element={<MobileMoldList />} />,
  <Route key="m-lifecycle" path="/mobile/mold-lifecycle" element={<MobileMoldLifecycle />} />,
  <Route key="m-hist-id" path="/mobile/mold-history/:moldId" element={guard(<MobileMoldHistory />, HISTORY_READ_ROLES)} />,
  <Route key="m-qrcode" path="/mobile/mold-qrcode" element={guard(<MobileMoldQRCode />, QR_OUTPUT_ALLOWED)} />,
  // QR 코드 바인딩 — 양산 금형 + plant/admin
  // P3 정정: 백엔드 molds.js:81-91 은 plant 도 자사 양산금형 바인딩 허용 → admin/dev/staff + plant
  //   (Phase JZ-104 M-4 의 "admin/dev/staff 만" 주석은 백엔드와 불일치했음)
  <Route key="m-qr-bind" path="/mobile/molds/:moldId/qr-bind" element={guard(<MobileMoldQRBind />, QR_BIND_ALLOWED)} />,
  // M-A3: /mobile/mold-location → /mobile/location-map alias (단일화)
  <Route key="m-location" path="/mobile/mold-location" element={<Navigate to="/mobile/location-map" replace />} />,

  /* 점검/승인/워크플로우 */
  <Route key="m-insp-appr2" path="/mobile/inspection-approval" element={guard(<MobileInspectionApproval />, APPROVER_ROLES)} />,
  <Route key="m-insp-new" path="/mobile/inspection-new" element={guard(<MobileInspectionNew />, INSPECTOR_ROLES)} />,
  <Route key="m-insp-new-id" path="/mobile/inspection-new/:id" element={guard(<MobileInspectionNew />, INSPECTOR_ROLES)} />,
  /* Phase AT: 레거시 /mobile/approval-inbox-legacy 라우트 + MobileApprovalInbox 페이지 완전 제거.
     Kit Inbox (/mobile/approval-inbox, 라인 68) 가 SSoT 단일. */
  <Route key="m-workflow" path="/mobile/workflow" element={<MobileWorkflow />} />,

  /* 체크리스트 */
  <Route key="m-precheck" path="/mobile/pre-production-checklist" element={<MobilePreProductionChecklist />} />,
  <Route key="m-precheck-id" path="/mobile/pre-production-checklist/:id" element={<MobilePreProductionChecklist />} />,
  <Route key="m-pt-check2" path="/mobile/production-transfer-checklist" element={<MobileProductionTransferChecklist />} />,

  /* 유지보전/폐기 */
  <Route key="m-maint" path="/mobile/maintenance" element={<MobileMaintenancePage />} />,
  <Route key="m-maint-tasks-unified" path="/mobile/maintenance-tasks/unified" element={<MobileMaintenanceTasksUnified />} />,
  <Route key="m-scrap" path="/mobile/scrapping" element={<MobileScrappingPage />} />,
  <Route key="m-scrap-new" path="/mobile/scrapping/new" element={<MobileScrappingPage />} />,
  // 2026-07-08: 금형별 폐기 진행현황 (PC /scrapping/progress 파리티 — :id 보다 먼저, 'progress' 정적 매칭 우선)
  <Route key="m-scrap-progress" path="/mobile/scrapping/progress" element={<MobileMoldScrappingProgress />} />,
  <Route key="m-scrap-id" path="/mobile/scrapping/:id" element={<MobileScrappingPage />} />,

  /* 업체 관리 — 관리자/개발자 전용 */
  <Route key="m-companies" path="/mobile/companies" element={guard(<MobileCompanyList />, ADMIN_DEV)} />,
  <Route key="m-company-id" path="/mobile/companies/:companyId" element={guard(<MobileCompanyDetail />, ADMIN_DEV)} />,

  /* 협력사 프로필 편집 (maker/plant 자사) */
  <Route key="m-company-profile" path="/mobile/company-profile" element={guard(<MobileCompanyProfile />, [R.MAKER, R.PLANT])} />,

  /* 알림/리포트 */
  <Route key="m-alerts" path="/mobile/alerts" element={<MobileAlerts />} />,
  <Route key="m-alert-detail" path="/mobile/alerts/detail/:id" element={<AlertDetail />} />,
  <Route key="m-notifs" path="/mobile/notifications" element={<MobileAlerts />} />,
  <Route key="m-notif-center" path="/mobile/notification-center" element={guard(<MobileNotificationCenter />, ADMIN_ONLY)} />,
  // Phase JT: 협력사 (plant/maker) 차단 유지. Phase JZ-68 B-H1: 내부 직원 (dev/staff) 은 PC 파리티로 허용
  // ⚠ Route 배열 사이 JSX 주석은 esbuild 파싱 충돌 — JS 라인 주석 사용
  <Route key="m-reports" path="/mobile/reports" element={guard(<MobileReports />, ADMIN_DEV_STAFF)} />,
  <Route key="m-stats" path="/mobile/statistics" element={guard(<MobileReports />, ADMIN_DEV_STAFF)} />,

  /* 점검 플로우 */
  <Route key="m-qr-redirect" path="/mobile/qr-scan" element={<Navigate to="/mobile/qr-login" replace />} />,
  <Route key="m-cl-select" path="/mobile/checklist-select" element={<ChecklistSelectPage />} />,
  <Route key="m-cl-form" path="/mobile/checklist-form" element={<ChecklistFormPage />} />,
  <Route key="m-cl-complete" path="/mobile/checklist-complete" element={<ChecklistCompletePage />} />,

  /* 대시보드/검색 */
  <Route key="m-dash" path="/mobile/dashboard" element={<MobileDashboard />} />,
  <Route key="m-search" path="/mobile/search" element={<MobileSearch />} />,

  /* 생산처 전용 */
  <Route key="m-plant-sel" path="/mobile/plant/select-mold/:task" element={guard(<MobilePlantMoldSelect />, PLANT_ONLY)} />,

  /* 사용자/세션/설정 */
  <Route key="m-user-req" path="/mobile/user-requests" element={guard(<MobileUserRequests />, ADMIN_DEV)} />,
  <Route key="m-qr-sess" path="/mobile/qr-sessions" element={guard(<MobileQRSessions />, ADMIN_ONLY)} />,
  <Route key="m-loc-map" path="/mobile/location-map" element={<MobileLocationMap />} />,
  <Route key="m-profile" path="/mobile/profile" element={<MobileProfile />} />,
  <Route key="m-my" path="/mobile/my" element={<MobileProfile />} />,
  <Route key="m-notif-set" path="/mobile/settings/notifications" element={<MobileNotificationSettings />} />,
  <Route key="m-notif-set2" path="/mobile/notification-settings" element={<MobileNotificationSettings />} />,
  <Route key="m-help" path="/mobile/help" element={<MobileHelp />} />,
  <Route key="m-about" path="/mobile/about" element={<MobileHelp />} />,

  /* R-10: 조회 목록 (신규) */
  <Route key="m-repair-hist" path="/mobile/mold-repair-history" element={<MobileMoldRepairHistory />} />,
  // 2026-07-08: 이관 이력관리/통계 (PC /mold-transfer-history 파리티 — 가드 없음, 인증만)
  <Route key="m-transfer-hist" path="/mobile/mold-transfer-history" element={<MobileMoldTransferHistory />} />,
  // Phase BD: 점검 결과 이력관리
  <Route key="m-insp-hist" path="/mobile/mold/:moldId/inspection-history" element={<MobileMoldInspectionHistory />} />,
  <Route key="m-overshot" path="/mobile/over-shot-molds" element={<MobileOverShotMoldList />} />,
  <Route key="m-insp-due" path="/mobile/inspection-due-molds" element={<MobileInspectionDueMoldList />} />,

  /* R-13: 금형 등록 (admin/mold_developer 전용) */
  <Route key="m-mold-new" path="/mobile/mold-new" element={guard(<MobileMoldNew />, ADMIN_DEV)} />,
  <Route key="m-mold-reg" path="/mobile/mold-registration" element={guard(<MobileMoldRegistration />, ADMIN_DEV)} />,

  /* Phase D — PC 파리티 신규 5건 */
  /* 협력사 담당자 현황 — admin/mold_developer */
  <Route key="m-partner-users" path="/mobile/partner-users" element={guard(<MobilePartnerUsers />, ADMIN_DEV)} />,

  // 2026-10-02: 투자비 관리 — 사용자 결정으로 **관리자 전용**. 서버 INVESTMENT_ROLES 미러.
  //   화면 안에서도 user_type 을 다시 보므로 라우트 가드는 1차 차단이다.
  <Route key="m-investment" path="/mobile/mold-investment" element={guard(<MobileInvestment />, ADMIN_ONLY)} />,
  // 사내 사용자 — 조회는 admin/dev, 쓰기는 화면 안에서 admin 단독으로 다시 좁힌다
  <Route key="m-internal-users" path="/mobile/users/internal" element={guard(<MobileInternalUsers />, ADMIN_DEV)} />,
  /* 사출기/장비/도장라인 집계 — P3: 전사 통계 격리 (PC 정책 파리티, admin/dev/staff only)
     협력사(maker/plant)는 자사 정보만 업체 프로필에서 조회 (MobileMore 2026-06-16 정책과 정합) */
  <Route key="m-partner-inj" path="/mobile/partner-injection-summary" element={guard(<MobilePartnerInjectionSummary />, ADMIN_DEV_STAFF)} />,
  <Route key="m-partner-eq" path="/mobile/partner-equipment-summary" element={guard(<MobilePartnerEquipmentSummary />, ADMIN_DEV_STAFF)} />,
  <Route key="m-partner-paint" path="/mobile/partner-paintline-summary" element={guard(<MobilePartnerPaintLineSummary />, ADMIN_DEV_STAFF)} />,
  /* 운영 리스크 모니터링 — admin/mold_developer */
  // Phase JZ-68 B-M4: 백엔드 riskMonitor authorize 는 staff 포함 (Phase AD) — 라우트 가드 정합
  <Route key="m-risk" path="/mobile/risk-monitor" element={guard(<MobileRiskMonitorDashboard />, ADMIN_DEV_STAFF)} />,
  <Route key="m-partner-ops" path="/mobile/partner-operations" element={guard(<MobilePartnerOperations />, PARTNER_OPS_ROLES)} />,
  /* 협력사 재무현황 (조회 전용) — 설계 §7.1: 협력사(plant/maker)는 자사 재무조차 볼 수 없다.
     서버 partnerFinance.js authorize([system_admin, mold_developer, staff]) 와 동일 역할 집합 */
  <Route key="m-partner-finance" path="/mobile/partner-finance" element={guard(<MobilePartnerFinance />, ADMIN_DEV_STAFF)} />,
  // 2026-09-17: 대여자산 실사 (SP-1 조회) — 협력사도 자사 할당 조회가 필요하므로 5역할 허용, 스코프는 서버가 강제
  <Route key="m-asset-audits" path="/mobile/asset-audits" element={guard(<MobileAssetAudit />, PARTNER_OPS_ROLES)} />,
  <Route key="m-asset-audit-detail" path="/mobile/asset-audits/:id" element={guard(<MobileAssetAudit />, PARTNER_OPS_ROLES)} />,

  /* 시스템 관리자 역할별 모바일 대시보드 (Phase GK: admin/dev/staff 동등 접근) */
  <Route key="m-dash-admin" path="/mobile/dashboard/system-admin" element={guard(<SystemAdminMobileDashboard />, ADMIN_DEV_STAFF)} />,

  /* Phase G-2: Unified Task Center (역할 무관 — 해야 할 작업 통합) */
  <Route key="m-tasks" path="/mobile/tasks" element={<MobileTaskCenter />} />,

  /* Phase HU: 더보기 메뉴 (하단바 5번째 탭) — 통계/협력사/운영/검색·설정 통합 */
  <Route key="m-more" path="/mobile/more" element={<MobileMore />} />,
  // Phase HV: KPI 시각화 페이지
  <Route key="m-kpi-dashboard" path="/mobile/kpi-dashboard" element={<MobileKPIDashboard />} />,

  /* 기존 호환 라우트 — P1-4: /mobile/molds/:moldId (legacy) → /mobile/mold/:moldId 리다이렉트 */
  <Route key="m-compat-mold" path="/mobile/molds/:moldId" element={<CompatMoldRedirect />} />,
  <Route key="m-compat-check" path="/mobile/molds/:moldId/check/:category" element={<ChecklistStartPage />} />,
  <Route key="m-compat-repair" path="/mobile/molds/:moldId/repair/requests" element={<RepairRequestListPage />} />,
  <Route key="m-compat-prog" path="/mobile/molds/:moldId/repair/progress" element={<RepairRequestListPage showStatusOnly />} />,
]

// P1-4: 레거시 /mobile/molds/:moldId → /mobile/mold/:moldId 리다이렉트
function CompatMoldRedirect() {
  const { moldId } = useParams();
  return <Navigate to={`/mobile/mold/${moldId}`} replace />;
}
